import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Timestamp } from '@dto';
import { GenericOldService } from './generic-old.service';

@Injectable({ providedIn: 'root' })
export class AccountStatsService {
  apiUrl: string;

  constructor(
    private resourceService: GenericOldService<number>,
    private statsResourceService: GenericOldService<Timestamp[]>,
  ) {
    this.apiUrl = resourceService.apiLocation;
  }

  getAggregatedEnergyCapacityForAccount$(accountId: string): Observable<number> {
    return this.resourceService.get(`accounts/${accountId}/aggregated-statistics/ENERGYCAPACITY`);
  }

  getAggregatedPowerCapacityForAccount$(accountId: string): Observable<number> {
    return this.resourceService.get(`accounts/${accountId}/aggregated-statistics/BESSPOWER`);
  }

  getBuildingDemandForAccount$(accountId: string): Observable<Timestamp[]> {
    return this.statsResourceService.get(`accounts/${accountId}/statistics/AGGREGATEDBUILDINGDEMAND`);
  }

  getSiteMeterForAccount$(accountId: string): Observable<Timestamp[]> {
    return this.statsResourceService.get(`accounts/${accountId}/statistics/SITEMETER`);
  }
}
